import { render, staticRenderFns } from "./ProductFamilyAll.vue?vue&type=template&id=470000f7&"
import script from "./ProductFamilyAll.vue?vue&type=script&lang=js&"
export * from "./ProductFamilyAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports